import { FC } from "react";
import { Flex, Text } from "@smile2impress/components/relaunch";
import { Icon, Icons } from "@smile2impress/components";
import { sanitizeHtml } from "@smile2impress/attraction-utils";

import { ListItemProps } from "./ListItem.types";

export const ListItem: FC<ListItemProps> = ({ text, icon }) => {
    const iconComponent =
        typeof icon === "string" ? Icons[icon as keyof typeof Icons] : icon;

    return (
        <Flex direction={["row"]} columnGap={[1, 1, 1]}>
            {iconComponent && (
                <Flex>
                    <Icon
                        w={"24px"}
                        h={"24px"}
                        as={iconComponent}
                        color="base.bitterSweet"
                    />
                </Flex>
            )}
            <Text
                textStyle="body"
                dangerouslySetInnerHTML={{
                    __html: sanitizeHtml(text),
                }}
            />
        </Flex>
    );
};
